import React from 'react'
import { useSelector } from 'react-redux';
import ReactSelect from '../ReactSelect';

const StateExceptions = ({ exp_states, handleChange, isSelected, disabled }) => {
    const { statesList } = useSelector(state => state.ConfigReducer)


    return (
        <div className='rule__values'>
            <ReactSelect
                disabled={disabled}
                placeholder={`Select States`}
                err={null}
                groupdOptions={statesList}
                defaults={exp_states}
                handleChange={states => {
                    if (!disabled) {
                        handleChange({ "exp_states": states })
                    }
                }}
            />
        </div>
    )
}

export default StateExceptions
